import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';
import 'firebase/compat/performance';

var config = {
  apiKey: 'AIzaSyDnXcUN_UkN9ayJVaCV2IGTnSuYMjOeuKA',
  authDomain: 'jsx-app-6a976.firebaseapp.com',
  projectId: 'jsx-app-6a976',
  storageBucket: 'jsx-app-6a976.appspot.com',
  messagingSenderId: '341319737605',
  appId: '1:341319737605:web:628dfee165f1adb3c0576c',
  measurementId: 'G-9ER4QZSJ1K',
};

// Initialize Firebase
firebase.initializeApp(config);

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const analytics = firebase.analytics();
export const perf = firebase.performance();

export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const microsoftProvider = new firebase.auth.OAuthProvider(
  'microsoft.com'
);
//Trigger google pop up whenever we use the google auth providder is used
googleProvider.setCustomParameters({ prompt: 'select_account', hd: 'jsx.com' });
// googleProvider.addScope("email");

microsoftProvider.setCustomParameters({ prompt: 'select_account' });

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      unsubscribe();
      resolve(userAuth);
    }, reject);
  });
};

export const signInWithGoogle = () =>
  auth
    .signInWithPopup(googleProvider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      // const credential = googleProvider.credentialFromResult(result);
      // const token = credential.accessToken;
      // The signed-in user info.
      // const userAuth = result.user;
      // console.log("Google token" + token);
    })
    .catch((error) => {
      console.log(error);
    });

export const signInWithMicrosoft = () =>
  auth
    .signInWithPopup(microsoftProvider)
    .then((result) => {
      // This gives you a Microsoft Access Token. You can use it to access the Microsoft API.
      // const credential = microsoftProvider.credentialFromResult(result);
      // const token = credential.accessToken;
      // The signed-in user info.
      // const userAuth = result.user;
      // console.log("Microsoft token" + token);
    })
    .catch((error) => {
      console.log(error);
    });

// Read up about analytics

// firebase.analytics();

export default firebase;
